import BusinessBankingAccounts from './BusinessBankingAccounts';

export default BusinessBankingAccounts;
